__turbopack_context__.v({
  "aboutPanelContents": "mobile-info-panel-module-scss-module__MybyeW__aboutPanelContents",
  "commentCitation": "mobile-info-panel-module-scss-module__MybyeW__commentCitation",
  "commentContents": "mobile-info-panel-module-scss-module__MybyeW__commentContents",
  "mobileInfoPanel": "mobile-info-panel-module-scss-module__MybyeW__mobileInfoPanel",
  "mobileInfoPanelHeader": "mobile-info-panel-module-scss-module__MybyeW__mobileInfoPanelHeader",
  "panelCloseIcon": "mobile-info-panel-module-scss-module__MybyeW__panelCloseIcon",
  "panelEmptyMessage": "mobile-info-panel-module-scss-module__MybyeW__panelEmptyMessage",
  "panelTitle": "mobile-info-panel-module-scss-module__MybyeW__panelTitle",
  "tabBodyWrapper": "mobile-info-panel-module-scss-module__MybyeW__tabBodyWrapper",
});
